"use client";

import { Box } from "@chakra-ui/react";
import { useParams } from "next/navigation";

import CompaniesCardSkeleton from "./CompaniesCardSkeleton";
import CompaniesListSkeleton from "./CompaniesListSkeleton";

const ListSkeletons = () => {

  const params =useParams()

  
  return (
    <>
      <Box display={{ base: "block", smx: "none" }}>
        <CompaniesCardSkeleton />
      </Box>
      <Box display={{ base: "none", smx: "block" }}>
      { !params?.company&& <CompaniesListSkeleton />}
      </Box>
    </>
  );
};

export default ListSkeletons;